// extracted by mini-css-extract-plugin
export var growableInput = "_52-0";
export var tagContainer = "_52-2";
export var textInput = "_52-1";